import { Injectable } from '@angular/core';
import {ContactStructure, Structure, StructureResister} from '../models/structure.model';
import {AuthService} from '../../securite/service/auth.service';
import {catchError, Observable, Subject} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Domaine, GeneralResponse, Specialite, TypeStructure} from '../../parametre/parametre.model';
import {map} from 'rxjs/operators';
import {Router} from '@angular/router';
import {of} from 'rxjs/internal/observable/of';
import {ToasterService} from '../../../globalServices/toaster.service';
import {Demande, Mission} from '../models/demande.model';
import {ParametreService} from '../../parametre/parametre.service';
import {MatDialog} from '@angular/material/dialog';
import {Information} from '../../admin/admin.model';
import {ModalContentComponent} from '../../admin/gestion-information/modal-content/modal-content.component';
import {environment} from '../../../../environments/environment';
const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
@Injectable({
  providedIn: 'root'
})
export class StructureService {
  public structure: Structure;
  public struc_is_loading=true;
    apiurl = environment.globals.urlApi;

  public urlFile="";
    public selectedMission: Mission;
    contactStructures: ContactStructure[];
  demandeStructures: Demande[];
  demandeStructureSubject = new Subject<Demande[]>();
  contactsStructureSubject = new Subject<ContactStructure[]>();
  structureSubject = new Subject<Structure>();
    public demandeViewSelected: Demande;
    public demandeEditSelected: Demande;
    public selectedTuteur: ContactStructure;

    public dmdTotal = {
        icon: "tag",
        counter: 0,
        name: "Toutes les demandes",
        font: "primary",
        pr: "+70",
    };
    public dmdEncours = {
        icon: "tag",
        counter: 0,
        name: "Demandes en cours",
        font: "primary",
        pr: "+70",
    };
    public dmdAccepter = {
        icon: "tag",
        counter: 0,
        name: "Demandes acceptées",
        font: "primary",
        pr: "+70",
    };
    public dmdRefuser = {
        icon: "tag",
        counter: 0,
        name: "Demandes refusées",
        font: "primary",
        pr: "+70",
    };

  constructor(
      private authService: AuthService,
              private http: HttpClient,
              private router: Router,
              private c: Router,
              private toastr: ToasterService,
      public parametreService: ParametreService,
      private dialog: MatDialog

  ) { }

    public getToken(): string | null {
        return window.sessionStorage.getItem(TOKEN_KEY);
    }
    getHeaders(token?: string) {

        if(this.getToken() !== null) {
            valueToken = this.getToken();
        } //console.log("Mon token",token);
        var valueToken = '';

        //console.log("Mon token",valueToken);

        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token!=undefined ? token: this.getToken()}`
        });

        // return {
        //   'Content-Type': 'application/json',
        //   'accept': 'application/json',
        //   'Access-Control-Allow-Origin': this.server,
        //   'Authorization': 'Bearer ' + token ? token: valueToken
        //   };
    }

  registerStructure(structureData: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getToken()}`
      })
    };

    return this.http.post<any>(this.apiurl + '/structure/new', structureData, {headers:this.getHeaders()});
  }
  updateStructure(structureData: Structure): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.getToken()}`
            })
        };

        return this.http.put<any>(this.apiurl + '/structure/update', structureData, httpOptions);
    }

  getContactsStructures(structure_id){

    this.http.post<GeneralResponse>(this.apiurl  + '/structure/contact/list', {
            'structure_id': `${structure_id}`
         }, {headers: this.getHeaders()})
        .pipe(
            map(response => {
              const datas = response.data as ContactStructure[]; // Type assertion for clarity

              return datas;
            }),
            catchError(error => {
              console.error('Error fetching contacts:', error);
              return of([]); // Return an empty observable on error
            })
        )
        .subscribe(
            {
              next: (responses: ContactStructure[]) => {
                this.contactStructures = responses;
                //console.log("contacts structure",this.contactStructures);
                this.emitContactStructure();
              },
            }
        );
  }

  fetchStructureByUser(user_id: number) {
      this.struc_is_loading=true;
    this.http.post<GeneralResponse>(this.apiurl + '/structure/by/user', {
      'user_id': `${user_id}`
    }, {headers:this.getHeaders()}).pipe(
        map((response: GeneralResponse) => {
          const data = response.data as Structure; // Type assertion for clarity
          //console.log('response structure', response);

          return data;
        })
    ).subscribe(
        {
          next: (response: Structure) => {
            this.structure = response;
            //console.log('response objet structure', response);
            if(Object.keys(this.structure).length === 0 ||this.structure ==null || (this.structure!=null && this.structure.id ==0)) {
              //console.log('struc exist pas', this.structure);
              this.router.navigate(['/structure','new']);

            }else {
              //console.log('struc exist', this.structure);
              this.emitStructure();
                this.router.navigate(['/structure','']);

            }
              // this.struc_is_loading=false;

          },
          error(err: any) {
              this.struc_is_loading=false;

              let erreurGeneral = new GeneralResponse();
            erreurGeneral = err;
            //console.log('oops', erreurGeneral);
          }
        }
    );
  }
  getStructureDataByUser(user_id: number) {
      this.struc_is_loading=true;

    this.http.post<GeneralResponse>(this.apiurl + '/structure/by/user', {
      'user_id': `${user_id}`
    }, {headers:this.getHeaders()}).pipe(
        map((response: GeneralResponse) => {
          const data = response.data as Structure; // Type assertion for clarity
          //console.log('response api struct ', response);
          return data;
        })
    ).subscribe(
        {
          next: (response: Structure) => {

            this.structure = response;
            console.log('response structure data', response);
            if(Object.keys(this.structure).length === 0 ||this.structure ==null || (this.structure!=null && this.structure.id ==0)) {
              console.log('struc exist pas', this.structure);
                this.router.navigate(['/structure','new']);
                // this.struc_is_loading=false;


            }else {
                console.log('struc exist', this.structure);

                if(!this.structure.profil_is_valide){
                    this.router.navigate(['/structure','edit']);

                }
                // if(!is_dashboard) {
                //     if(!this.structure.profil_is_valide){
                //         this.router.navigate(['/candidat','edit']);
                //
                //     }
                // }

              //console.log('struc exist', this.structure);
                this.getContactsStructures(this.structure.id);
                this.getDemandesDataByStruc();

                this.emitStructure();
                this.struc_is_loading=false;

            }
          },
          error(err: any) {
              this.struc_is_loading=false;

              let erreurGeneral = new GeneralResponse();
            erreurGeneral = err;
            //console.log('oops', erreurGeneral);
          }
        }
    );
  }
    getInfos(httpHeaders:HttpHeaders,roleId,type):Observable<Information[]> {

        return this.http.post<GeneralResponse>(this.apiurl  + '/admin/user/information/list',{
            'role_id':roleId,
            'type':type
        }, {headers: httpHeaders})
            .pipe(
                map(response => {
                    return response.data as Information[]; // Type assertion for clarity

                }),
                catchError(error => {
                    console.error('Error fetching Informations:', error);
                    return of([]); // Return an empty observable on error
                })
            )

    }

    getStructureForInfoByUser(user_id: number,type:string) {

        this.http.post<GeneralResponse>(this.apiurl + '/structure/by/user', {
            'user_id': `${user_id}`
        }, {headers:this.getHeaders()}).pipe(
            map((response: GeneralResponse) => {
                const data = response.data as Structure; // Type assertion for clarity
                //console.log('response api struct ', response);
                return data;
            })
        ).subscribe(
            {
                next: (response: Structure) => {

                    this.structure = response;
                    //console.log('response structure data', this.structure);
                    if(Object.keys(this.structure).length === 0 ||this.structure ==null || (this.structure!=null && this.structure.id ==0)) {
                        //console.log('struc exist pas', this.structure);
                        //console.log('user logged', this.authService.loggedUser);
                        // this.struc_is_loading=false;

                        this.getInfos(this.getHeaders(),this.authService.loggedUser.role_id,type)
                            .subscribe(
                                {
                                    next: (responses: Information[]) => {

                                        if (responses != undefined && responses.length > 0) {
                                            // const infos = responses.find(item => item.type === 'GUIDE'&&item.role.titre === 'structure');
                                            // //console.log("Information a afficher",infos);
                                            // this.htmlString = ""+infos.titre+" <br>"+infos.contenu;
                                            const infos :Information[] = responses.filter(item => item.type === 'GUIDE'&&item.role.titre === 'structure'&&item.isDefault === true);
                                            //console.log("Information a afficher",infos);

                                           var htmlString = infos.map(info => `${info.titre} ${info.contenu}`).join('<br>');


                                            //console.log("Information htmlString", htmlString);

                                            this.dialog.open(ModalContentComponent, {
                                                data: htmlString,
                                                width: '900px',
                                                // height: '600px',
                                            });
                                        }else {
                                            //console.log("Information a afficher vide",responses);

                                        }
                                    },
                                }
                            );


                    }else {


                    }
                },
                error(err: any) {
                    this.struc_is_loading=false;

                    let erreurGeneral = new GeneralResponse();
                    erreurGeneral = err;
                    //console.log('oops', erreurGeneral);
                }
            }
        );
    }

  emitStructure() {
    this.structureSubject.next(this.structure);
  }
  emitContactStructure() {
    this.contactsStructureSubject.next(this.contactStructures);
  }

    emitDemandeStructure() {
        this.demandeStructureSubject.next(this.demandeStructures);
    }
  get currentStructure() {
    //console.log("Current structure",this.structure);
    return this.structure;
  }


  deleteContact(contact_id): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.parametreService.getToken()}`
      })
    };

    return this.http.post<any>(this.apiurl + '/structure/contact/delete', {
      'contact_id':contact_id
    }, httpOptions);
  }



    selectTuteur(selectedTuteur: ContactStructure) {
        this.selectedTuteur=selectedTuteur
    }


    getDemandesDataByStruc() {

        this.http.post<GeneralResponse>(this.apiurl + '/structure/demande/mission/list/by/str', {
            'structure_id': `${this.structure.id}`
        }, {headers:this.getHeaders()}).pipe(
            map((response: GeneralResponse) => {
                const data = response.data as Demande[]; // Type assertion for clarity
                //console.log('response demandes', response);
                return data;
            })
        ).subscribe(
            {
                next: (response: Demande[]) => {
                    this.demandeStructures = response;
                    let data=this.demandeStructures;
                    //console.log('response dmd', this.demandeStructures);
                    this.dmdTotal = {
                        icon: "tag",
                        counter: data.length,
                        name: "Toutes les demandes",
                        font: "primary",
                        pr: "0",
                    };
                    this.dmdEncours  = {
                        icon: "tag",
                        counter: data.filter(dmd => dmd.etat === 'E').length,
                        name: "Demandes en cours",
                        font: "primary",
                        pr: "0",
                    };
                    this.dmdAccepter = {
                        icon: "tag",
                        counter: data.filter(dmd => dmd.etat === 'A').length,
                        name: "Demandes acceptées",
                        font: "primary",
                        pr: "0",
                    };
                    this.dmdRefuser = {
                        icon: "tag",
                        counter: data.filter(dmd => dmd.etat === 'R').length,
                        name: "Demandes refusées",
                        font: "primary",
                        pr: "0",
                    };
                    this.emitDemandeStructure();
                },
                error(err: any) {
                    this.router.navigate(['/structure','view']);

                    let erreurGeneral = new GeneralResponse();
                    erreurGeneral = err;
                    //console.log('oops', erreurGeneral);
                }
            }
        );
    }

    newDemande(demandeData: any): Observable<any> {


        return this.http.post<any>(this.apiurl + '/structure/demande/mission/new', demandeData, {headers:this.getHeaders()});
    }
    updateDemande(demandeData: any): Observable<any> {


        return this.http.put<any>(this.apiurl + '/structure/demande/update', demandeData, {headers:this.getHeaders()});
    }

    /** Valide (V) ou refuse (R) une demande de structure. Payload : { id, etat, commentaire, comment_user_id }. */
    validerDemande(demandeData: any): Observable<any> {
        return this.http.put<any>(this.apiurl + '/structure/demande/valider', demandeData, {headers:this.getHeaders()});
    }

    updateMission(missionData: any): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.parametreService.getToken()}`
            })
        };

        return this.http.put<any>(this.apiurl + '/structure/mission/update', missionData, {headers:this.getHeaders()});
    }


}
